import { Transaction } from '../../../domain/transaction';
import { useFetch } from '../../../hooks/useFetch';
import { PageableResponseWrapper, PageQueryParams } from '../../../domain/response-wrapper';
import { useState } from 'react';
import { usePagination } from '../../../hooks/usePagination';
import { getFormatToSendApi, getLastDaysDateRange } from '../../home/util/GetDateRangeUtil';

// Transacciones abre por defecto con el día actual (start = end = hoy).
export const TRANSACTIONS_DEFAULT_RANGE_DAYS = 1;

export interface TransactionFiltersQueryParams extends PageQueryParams {
  idBranch?: string[];
  cardBrand?: string[];
  idMerchant?: string[];
  operationId?: string[];
  operationType?: string[];
  operationNumber?: string;
  paymentMethod?: string[];
  serialNumber?: string;
  status?: string[];
  amountStart?: string;
  amountEnd?: string;
  start?: string;
  end?: string;
}

export const buildDefaultTransactionFilters = (today: Date = new Date()): TransactionFiltersQueryParams => {
  const { startDate, endDate } = getFormatToSendApi(getLastDaysDateRange(TRANSACTIONS_DEFAULT_RANGE_DAYS, today));
  return {
    page: 0,
    size: 10,
    status: [],
    paymentMethod: [],
    operationType: [],
    operationNumber: undefined,
    cardBrand: [],
    idMerchant: [],
    idBranch: [],
    serialNumber: undefined,
    amountStart: undefined,
    amountEnd: undefined,
    start: startDate,
    end: endDate,
  };
};

export const useTransactionFilters = () => {
  const [initialFilters] = useState(() => buildDefaultTransactionFilters());
  const {
    queryParams,
    setParam,
    prevPage,
    nextPage,
    updateParams,
  } = usePagination<TransactionFiltersQueryParams>(initialFilters);

  const {
    data,
    loading,
    error,
  } = useFetch<PageableResponseWrapper<Transaction>>('/transactions-view', queryParams);

  const search = (key: keyof TransactionFiltersQueryParams, value: string | string[] | undefined) => {
    queryParams.page = 0;

    if (key === 'status') {
      if (Array.isArray(value)) {
        setParam(key, value);
      } else {
        setParam(key, value);
      }
    } else {
      setParam(key, value);
    }
  };

  const resetFilters = () => {
    updateParams(buildDefaultTransactionFilters())
  }

  return {
    queryParams,
    results: data,
    error,
    loading,
    search,
    prevPage,
    nextPage,
    updateParams,
    resetFilters,
  };
};
